import {TargetBlank} from '@wandb/weave/common/util/links';
// @todo: Migrate to @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React from 'react';

import DocUrls from '../../../util/doc_urls';

export const RegistriesHomePageHeader = ({
  showCreateRegistryButton,
  onCreateRegistry,
}: {
  showCreateRegistryButton: boolean;
  onCreateRegistry: () => void;
}) => {
  return (
    <Tailwind>
      <div className="flex items-center gap-8">
        <div className="mr-2 text-2xl font-semibold leading-10">Registry</div>
        <div className="flex-grow" />
        <TargetBlank href={DocUrls.registry}>
          <Button
            size="large"
            variant="secondary"
            className="flex items-center justify-center gap-8"
            icon="documentation">
            Documentation
          </Button>
        </TargetBlank>
        {showCreateRegistryButton && (
          <Button
            data-test="create-registry"
            size="large"
            variant="primary"
            className="flex items-center justify-center gap-8"
            icon="add-new"
            onClick={onCreateRegistry}>
            Create registry
          </Button>
        )}
      </div>
    </Tailwind>
  );
};
